import React from 'react';
import KanbanPage from './KanbanPage';

export default function WaKanbanWrapper() {
  return <KanbanPage />;
}
